import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import {hextToHexString} from '@Utils/color.util';
import type {BrandKitTagProps} from './brand-kit-tag.types';
import {BRAND_KIT_TAG_COLOR_CIRCLES_COUNT} from './brand-kit-tag.types';
import styles from './brand-kit-tag.module.scss';

export function BrandKitTag({brandKitName, brandKitColors, logoThumbSrc}: BrandKitTagProps): ReactElement {
  /** Last colour first: the stack lays out right-to-left so earlier circles paint on top (see the stylesheet). */
  const getColorCircles = (): ReactElement[] => {
    return brandKitColors
      .slice(0, BRAND_KIT_TAG_COLOR_CIRCLES_COUNT)
      .reverse()
      .map((hexCode, index) => {
        return <span key={index} className={styles.colorCircle} style={{backgroundColor: hextToHexString(hexCode)}} />;
      });
  };

  return (
    <div className={styles.brandKitTag}>
      <div className={styles.circlesStack}>
        {getColorCircles()}
        <span className={`${styles.colorCircle} ${styles.logoCircle}`}>
          <img src={logoThumbSrc} alt={brandKitName} draggable="false" loading="lazy" />
        </span>
      </div>
      <Text className={styles.brandKitNameText} val={brandKitName} size={TextSize.XS} bold />
    </div>
  );
}
